import React from 'react';
import styled from 'styled-components';
import SvgIcon from '@material-ui/core/SvgIcon';
import { useCookies } from 'react-cookie';
import Badge from '../../../../Icons/Badge';
import { CookieNames } from '../../../../../../config';

const Root = styled.div`
  position: relative;
  height: 24px;
`;

export default () => {
  const [cookies] = useCookies([CookieNames.INSURANCE_BADGE]);

  return (
    <Root>
      {!cookies[CookieNames.INSURANCE_BADGE] && <Badge />}

      <SvgIcon>
        <svg fill="none">
          <path
            d="M3 11.5C3 18 11.506 22 12.003 22C12.5 22 21 18 21 11.5C21 9.56042 21.0001 5 21.0001 5C21.0001 5 14.0831 2.57382 12 2C12 2 3.4815 4.81464 3 5C3 5 3 9.56042 3 11.5Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
          />
          <path
            d="M8 11L11 14L16.5 8.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
          />
        </svg>
      </SvgIcon>
    </Root>
  );
};
